{
  "name": "@iexec/poco",
  "version": "5.3.0",
  "description": "",
  "main": "truffle.js",
  "scripts": {
    "build": "truffle compile",
    "migrate": "truffle migrate",
    "test": "truffle test",
    "autotest": "./autotest.sh",
    "coverage": "NODE_OPTIONS='--max-old-space-size=8192' truffle run coverage",
    "verify": "NODE_OPTIONS='--max-old-space-size=8192' truffle run verify"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/iExecBlockchainComputing/PoCo-dev.git"
  },
  "bugs": {
    "url": "https://github.com/iExecBlockchainComputing/PoCo-dev.git/issues"
  },
  "files": [
    "/build",
    "/contracts"
  ],
  "author": "iExec",
  "license": "Apache-2.0",
  "homepage": "https://github.com/iExecBlockchainComputing/PoCo-dev.git#readme",
  "dependencies": {
    "@iexec/erlc": "1.0.0",
    "@iexec/interface": "3.0.35-8",
    "@iexec/solidity": "0.1.0-legacy",
    "@openzeppelin/contracts": "3.3.0",
    "@uniswap/v2-periphery": "1.1.0-beta.0",
    "rlc-faucet-contract": "1.0.9"
  },
  "devDependencies": {
    "@ensdomains/ens": "0.4.5",
    "@ensdomains/resolver": "0.2.4",
    "@openzeppelin/test-helpers": "^0.5.10",
    "@truffle/hdwallet-provider": "^1.2.1",
    "chai": "4.2.0",
    "eth-sig-util": "3.0.0",
    "ethers": "^5.0.25",
    "ganache-cli": "6.12.1",
    "husky": "^4.3.7",
    "solidity-coverage": "0.7.13",
    "truffle": "^5.1.61",
    "truffle-plugin-verify": "^0.5.4"
  }
}
